module.exports = __webpack_public_path__ + "img/sort-arrow.98722af0.svg";